import React from "react";
import styles from "./empty-tickets-inbox-tickets-page.module.scss";
import { SubTitle } from "@src/components/atoms/sub-title/sub-title";
import { FlexColumnContainer } from "@src/components/templates/layouts/flex-column-container/flex-column-container";
import { useI18N } from "@src/language/language-context";

const cssClassName = "empty-tickets-inbox-tickets-page";

export default function EmptyTicketsInboxTicketsPage() {
  const i18n = useI18N();

  const texts = {
    emptyInboxTitle: i18n(
      "modules.emptyTicketsInboxTicketsPage.emptyInboxTitle",
    ),
    emptyInboxMessage: i18n(
      "modules.emptyTicketsInboxTicketsPage.emptyInboxMessage",
    ),
  };

  return (
    <div className={styles[cssClassName]}>
      <FlexColumnContainer verticalGap={12} alignItems="center">
        <SubTitle text={texts.emptyInboxTitle} />
        <p className={styles[`${cssClassName}__message`]}>
          {texts.emptyInboxMessage}
        </p>
      </FlexColumnContainer>
    </div>
  );
}
